import apiClient from "./apiClient";

const dashboardService = {
  getLocations: (search = "") =>
    apiClient.get("/api/v1/dashboard/locations", {
      params: { search },
    }),
    
  getServiceCostByCategory: (location, startDate, endDate) =>
    apiClient.get(`api/v1/dashboard/service-costs/breakdown?location=${location}&startDate=${startDate}&endDate=${endDate}`),

  getDashboardOverview: (areaCode, startDate, endDate) =>
    apiClient.get("/api/v1/dashboard/overview", {
      params: { areaCode, startDate, endDate },
    }),
  getAssets: (areaCode, search = "", riskStatus = []) =>
    apiClient.get("/api/v1/assets", {
      params: {
        areaCode,
        ...(search && { search }),
        ...(riskStatus?.length > 0 && { riskStatus }),
      },
      paramsSerializer: (params) => {
        const parts = [];
        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => parts.push(`${key}=${encodeURIComponent(v)}`));
          } else {
            parts.push(`${key}=${encodeURIComponent(value)}`);
          }
        });
        return parts.join("&");
      },
    }),
  getAiInsights: (areaCode, startDate, endDate) =>
    apiClient.get("/api/v1/dashboard/ai-insights", {
      params: { areaCode, startDate, endDate },
    }),

  getOptimizationGoals: (plantId) =>
    apiClient.get("/api/v1/dashboard/optimization-goals", {
      params: { plantId },
    }),

  updateOptimizationGoals: (plantId, maximizeUptime, minimizeCost) =>
    apiClient.put("/api/v1/dashboard/optimization-goals", {
      plantId,
      maximizeUptime,
      minimizeCost,
    }),

    getWorkOrders: (location = null, assetId = null, status = null) => {
      const params = {};
      if (location) params.location = location;
      if (assetId) params.assetId = assetId;
      if (status) params.status = status;
      return apiClient.get(`api/v1/dashboard/work-orders`, { params });
    },

    getAssignedAssets: (location = null) => {
      const params = {};
      if (location) params.location = location;
      return apiClient.get(`api/v1/TechnicianDashboard/assigned`, { params });
    }
};
export default dashboardService;